import { GET_PAYMENTS_FAILURE, GET_PAYMENTS_REQUEST, GET_PAYMENTS_SUCCESS, } from "./ActionType";


const initialState={
    loading:false,
    payments:[],
    error:"",
}

const vendorPaymentReducer=(state=initialState,action)=>{
    switch (action.type) {
        case GET_PAYMENTS_REQUEST:
            return {...state,loading:true};

        case GET_PAYMENTS_SUCCESS:
            return {...state,loading:false,payments:action.payload,error:""};

        case GET_PAYMENTS_FAILURE:
            return {...state,loading:false,orders:[],error:action.payload};

        default:
            return state;
    }
}
export default vendorPaymentReducer